import React from 'react';
import { Row, Col, Card, Button } from 'react-bootstrap';
import { BsRobot, BsGraphUp, BsPeople } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';

const SellerTools: React.FC = () => {
  const navigate = useNavigate();

  const tools = [
    {
      icon: <BsRobot size={48} />,
      title: "What's My Home Worth?",
      description: "Get an instant AI-powered valuation with real MLS comps — trained on 1.6M+ closed transactions",
      cta: "Get Your Home Value",
      action: () => navigate('/home-value')
    },
    {
      icon: <BsGraphUp size={48} />,
      title: "AI Market Analysis",
      description: "See what similar homes sold for in your neighborhood, average days on market, and pricing trends",
      cta: "See Market Data",
      action: () => navigate('/home-value')
    },
    {
      icon: <BsPeople size={48} />,
      title: "Talk to Our Broker",
      description: "Ready to sell? Connect directly with our designated broker for a personalized listing strategy",
      cta: "Contact Us",
      action: () => navigate('/find-agent')
    }
  ];

  return (
    <div className="seller-tools-section">
      <h2 className="section-title">Thinking of Selling?</h2>
      <p className="section-subtitle">
        AI-powered tools to maximize your home's value
      </p>
      
      <Row>
        {tools.map((tool, idx) => (
          <Col key={idx} md={4} className="mb-5">
            <Card className="tool-card h-100">
              <Card.Body className="text-center">
                <div className="tool-icon">{tool.icon}</div>
                <h4 className="tool-title">{tool.title}</h4>
                <p className="tool-description">{tool.description}</p>
                <Button 
                  variant="outline-primary" 
                  className="tool-cta"
                  onClick={tool.action}
                >
                  {tool.cta}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="seller-cta">
        <Card className="cta-card">
          <Card.Body>
            <Row className="align-items-center">
              <Col md={8}>
                <h3>Ready to Sell? Let AI Guide You</h3>
                <p className="mb-0">
                  Our AI analyzes thousands of data points to help you sell for top dollar
                </p>
              </Col>
              <Col md={4} className="text-md-end">
                <Button
                  variant="primary"
                  size="lg"
                  onClick={() => navigate('/home-value')}
                >
                  Start Selling
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    </div>
  );
};

export default SellerTools;